module.exports = __webpack_public_path__ + "img/share-report.5a7e670e.png";